import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInputConsumption } from 'common/components/form';

import { getSectionHasErrors } from '../../helpers';

import FormAccordion from './FormAccordion';

const DemandFields = ({ control, disabled, errors }) => {
    const fieldsKeys = useWatch({ control, name: 'fields_keys' });
    const { t } = useTranslation();

    if (!fieldsKeys?.demand?.length) return null;

    return (
        <FormAccordion
            defaultExpanded
            hasFormErrors={getSectionHasErrors(errors, ['demand'])}
            title={t('Demand')}
        >
            <Grid container>
                {fieldsKeys.demand.map((key) => (
                    <Grid
                        key={`demand-${key}`}
                        size={{ md: 'grow', xs: 18 }}
                        sx={{ minWidth: 200 }}
                    >
                        <ReactHookFormIntlNumberInputConsumption
                            append="kW"
                            control={control}
                            decimalsLimit={2}
                            disabled={disabled}
                            fullWidth
                            name={`demand.${key}`}
                            variant="standard"
                        />
                    </Grid>
                ))}
            </Grid>
        </FormAccordion>
    );
};

DemandFields.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
};

export default DemandFields;
